import { Route, Redirect, Switch } from "react-router-dom";
import { Reports } from "../../../pages/dashboard/userDashboard/v2/Pages/Reports";
import { SelfAssessmentForm } from "../SelfAssessmentForm";
import { ResetPassword } from "../../../pages/Auth/ResetPassword";
import HrAccount from "../../../pages/account/mentoraccount";
import { Mentoring } from "../../../pages/mentoring/mentorDashboard/v2/Pages/Mentoring";
import { MenteeProfile } from "../../../pages/mentoring/mentorDashboard/menteeProfile";
import { Learning } from "../../../pages/dashboard/userDashboard/v2/Pages/Learning";
import Journeys from "../../../pages/dashboard/userDashboard/userLearning/journeys/journeys";
import SingleJourney from "../../../pages/dashboard/userDashboard/userLearning/journeys/singleJourney/singleJourney";
import { Scheduler } from "../../../services/Scheduling/Scheduler/Scheduler";
import { Settings } from "../Settings";
import Connections from "../Connections/Connections";
import { useUser, useUserCompany } from "../../../features/User/userQueries";

import ConnectionProfile from "../ConnectionProfile/ConnectionProfile";
import Programs from "../Programs/Programs";
import { loadComponent } from "../../../lib/utils";
import { lazy, useMemo } from "react";
import { withSuspense } from "../../../lib/HOCs/withSuspense";
import { withErrorBoundary } from "../../../lib/HOCs/withErrorBoundary";
import PageSkeleton from "../../../components/skeletons/PageSkeleton";
import Sessions from "../../../features/Sessions/ui/Sessions";
import UserSurveyInvitation from "../../../features/Surveys/ui/SurveyInvitation/UserSurveyInvitation";
import ExpertAvailability from "../../../features/Calendar/ui/ExpertAvailability";

import NewExpertDashboard from "../../../pages/ExpertDashboard/ExpertDashboard";
import { SessionSummary } from "../../../features/Sessions/ui/SessionSummary";
// import NewExpertDashboard from "../../../pages/ExpertDashboard/NewExpertDashboard";

const LazyProgram = lazy(() => loadComponent(() => import("../Programs/Program")));
const Program = withSuspense(withErrorBoundary(LazyProgram), {
  fallBackComponent: <PageSkeleton />
});

const LazyNotificationCenter = lazy(() => loadComponent(() => import("../../../features/Notifications/ui/NotificationCenter")));

const NotificationCenter = withErrorBoundary(
  withSuspense(LazyNotificationCenter, {
    fallBackComponent: <PageSkeleton height={`calc(${window.innerHeight}px - 357px)`} />
  })
);
const LazyProgramRegistration = lazy(() =>
  loadComponent(() => import("../../../features/Programs/ui/ProgramRegistration/ProgramRegistration"))
);

const ProgramRegistration = withErrorBoundary(
  withSuspense(LazyProgramRegistration, {
    fallBackComponent: <PageSkeleton height={`calc(${window.innerHeight}px - 357px)`} />
  })
);
const ExpertDashboard = () => {
  const { data: company } = useUserCompany();
  const { data: user } = useUser({
    select: (user) => {
      return {
        account_type: user.account_type
      };
    }
  });

  const schedulingEnabled = useMemo(() => {
    if (user?.account_type === "Coach") {
      return true;
    }

    if (company && company?.schedulingSupported) return true;
  }, [company]);

  return (
    <Switch>
      <Route exact path="/dashboard" component={NewExpertDashboard} />
      <Route exact path="/programs" component={Programs} />

      <Route exact path="/sessions" component={Sessions} />
      <Route exact path="/sessions/session-summary/:sessionId" component={SessionSummary} />
      {company?.features?.includes("Assessment") && <Route exact path="/reports" component={Reports} />}
      {schedulingEnabled && <Route exact path="/availability" component={ExpertAvailability} />}
      <Route exact path="/scheduler" component={Scheduler} />
      <Route exact path="/scheduler/:programId" component={Scheduler} />
      <Route exact path="/scheduler/:programId/:userId" component={Scheduler} />
      <Route exact path="/scheduler/session/:sessionId" component={Scheduler} />
      <Route exact path="/self-assessment" component={SelfAssessmentForm} />
      <Route exact path="/programs/:programId/:r" component={Program} />
      <Route exact path="/fill-survey/:invitationId" component={UserSurveyInvitation} />
      <Route exact path="/reset-password" component={ResetPassword} />
      <Route exact path="/reset-password/:id" component={ResetPassword} />
      <Route exact path="/account" component={HrAccount} />
      <Route exact path="/mentoring" component={Mentoring} />
      <Route exact path="/mentee-profile" component={MenteeProfile} />
      {company?.features?.includes("Learning") && <Route exact path="/learning" component={Learning} />}
      <Route exact path="/journeys" component={Journeys} />
      <Route exact path="/journey" component={SingleJourney} />
      <Route exact path="/journey/:slug" component={SingleJourney} />
      <Route exact path="/settings" component={Settings} />
      <Route exact path="/connections" component={Connections} />
      <Route exact path="/connections/:id" component={ConnectionProfile} />
      <Route exact path="/profile/:id" component={ConnectionProfile} />
      <Route exact component={ProgramRegistration} path="/program-application/:id" />
      <Route exact component={ProgramRegistration} path="/program-application/:id" />

      <Route exact path="/notification-center" component={NotificationCenter} />
      <Redirect to="/dashboard" />
    </Switch>
  );
};

export default ExpertDashboard;
